define(["underscore","@aria/webjs-sdk","@bingads-webui/listener"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AriaListener", {
  enumerable: true,
  get: function get() {
    return _ariaListener.AriaListener;
  }
});

var _ariaListener = __webpack_require__(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AriaListener = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _webjsSdk = __webpack_require__(4);

var _listener = __webpack_require__(5);

var _defaultConfig = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const activeListeners = [];
let flushEventAttached = false;

function registerListener(listener) {
  activeListeners.push(listener);

  if (!flushEventAttached) {
    window.addEventListener('beforeunload', () => {
      activeListeners.forEach(l => l.flushLogs(false));

      _webjsSdk.AWTLogManager.flush();
    });
    flushEventAttached = true;
  }
}
/**
 * Create an instance of an Aria listener
 */


class AriaListener extends _listener.Listener {
  constructor(options = {}) {
    super(options);
    this.options = _underscore.default.defaults(options, {
      flushInterval: _defaultConfig.defaultConfig.flushInterval,
      batchSize: _defaultConfig.defaultConfig.batchSize,
      enableSessionTracking: _defaultConfig.defaultConfig.enableSessionTracking
    });
    this.formatters = _underscore.default.defaults(this.options.formatters || {}, _defaultConfig.defaultConfig.formatters);
    this.filters = this.options.filters || [];
    this.logTableNames = this.options.logTableNames;
    this.defaultLogCategory = this.options.defaultLogCategory;
  }
  /**
   * init aria listener
   * @returns {undefined} - no returns
   */


  init() {
    if (!this.options.tenantToken || this.initialized) {
      return;
    }

    this.logs = []; // Setup AriaTelemetry

    _webjsSdk.AWTLogManager.initialize(this.options.tenantToken);

    _webjsSdk.AWTLogManager.setTransmitProfile(_webjsSdk.AWT_NEAR_REAL_TIME);

    this.defaultLogger = _webjsSdk.AWTLogManager.getLogger(this.options.tenantToken);

    if (this.options.enableSessionTracking) {
      this.defaultLogger.logSession(_webjsSdk.AWTSessionState.Started);
    }

    if (!_webjsSdk.AWTLogManager.trackedListenerRefs) {
      _webjsSdk.AWTLogManager.trackedListenerRefs = {
        count: 0
      };
    }

    setInterval(() => this.flushBatch(), this.options.flushInterval);
    registerListener(this);
    this.initialized = true;
  }
  /**
   * register instance for final flush of logs to Aria
   * @private
   * @returns {undefined} - no returns
   */


  registerForTeardown() {
    if (this.registeredForTeardown || !this.initialized) {
      return;
    }

    this.registeredForTeardown = true;
    _webjsSdk.AWTLogManager.trackedListenerRefs.count += 1;
  }
  /**
   * flushes logs to Aria and tears down the logger
   * @returns {undefined} - no returns
   */


  teardown() {
    if (!this.initialized) {
      return;
    }

    this.flushAll(false);
    this.initialized = false;

    if (this.options.enableSessionTracking) {
      this.defaultLogger.logSession(_webjsSdk.AWTSessionState.Ended);
    }

    if (this.registeredForTeardown) {
      _webjsSdk.AWTLogManager.trackedListenerRefs.count -= 1;
    }

    this.release();
  }
  /**
  * flushes logs to aria telemetry logger
  * @param {bool} batchLogs - specify if the logs should be flushed in batches
  * @private
  * @returns {undefined} - no returns
   */


  flushLogs(batchLogs) {
    const useBatching = batchLogs && this.logs.length > this.options.batchSize;
    const batchSize = useBatching ? this.options.batchSize : this.logs.length;
    const logsToFlush = this.logs.splice(0, batchSize);

    _underscore.default.each(logsToFlush, log => {
      this.defaultLogger.logEvent(log);
    });
  }
  /**
   * If there are no active listeners then tear down the underlying logger.
   * @private
   * @returns {undefined} - no returns
   */


  release() {
    if (_webjsSdk.AWTLogManager.trackedListenerRefs.count === 0) {
      _webjsSdk.AWTLogManager.flushAndTeardown();
    }
  }
  /**
   * writes logs to the listener
   * @param {object} logMessage - logs to be written
   * @returns {undefined} - no returns
   */


  write(logMessage) {
    if (!this.initialized || this.filterLogs(logMessage)) {
      return;
    }

    const categoryName = this.getCategoryName(logMessage.logCategory);
    const formattedMsg = this.formatLogs(logMessage);
    this.logs.push({
      name: this.logTableNames[categoryName].name,
      properties: formattedMsg
    });
  }
  /**
   * @private
   * @returns {undefined} - no returns
   */


  flushAll() {
    this.flushLogs(false);
  }
  /**
   * @private
   * @returns {undefined} - no returns
   */


  flushBatch() {
    this.flushLogs(true);
  }
  /**
   * @private
   * @param {object} logCategory - logs to be written
   * @returns {undefined} - no returns
   */


  getCategoryName(logCategory) {
    const isValidLogCategory = _underscore.default.has(this.logTableNames, logCategory);

    return isValidLogCategory ? logCategory : this.defaultLogCategory;
  }

}

exports.AriaListener = AriaListener;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = void 0;

var _logPropertyFormatter = __webpack_require__(7);

const propertyFormatter = new _logPropertyFormatter.AriaPropertyFormatter();
const defaultConfig = {
  formatters: {
    propertyFormatter
  },
  enableSessionTracking: true,
  flushInterval: 5000,
  batchSize: 50
};
exports.defaultConfig = defaultConfig;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AriaPropertyFormatter = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _listener = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class AriaPropertyFormatter extends _listener.Formatter {
  format(logMessage) {
    return _underscore.default.mapObject(logMessage, val => ({
      value: val
    }));
  }

}

exports.AriaPropertyFormatter = AriaPropertyFormatter;

/***/ })
/******/ ])});;
